import BookingDatesWeb from "./bookingDates/web";
import RoomInfWeb from "./roomInf/web";
import { useTranslation } from "react-i18next";
import CalendarWeb from "components/calendar/web";
import Button from "components/button/default";
import { useNavigate, useParams } from "react-router-dom";
import { useBookInfContext } from "components/context/bookInfContext";
import { alertControl } from "util/commAction";
import { useRef } from "react";
import "./home.scss";

export default function HomeWeb() {
  const { t } = useTranslation();
  const { lodNo } = useParams();
  const navigate = useNavigate();
  const { dateRange, dates, promCd, bookInf, onBookInf } = useBookInfContext();
  const infRef = useRef<any | null>(null);

  return (
    <div className="home-web">
      <div className="text-center pt-[3rem] pb-2rem]">
        <h1>Reservation</h1>
        {/* <h5 className="text-blue-300">{t("bck_ttl_hm_ldg_dt_slt")}!</h5> */}
      </div>

      {/* 달력 날짜 선택  */}
      <CalendarWeb />

      {/* 선택된 숙박일   */}
      <BookingDatesWeb />

      {/* 인원 선택 */}
      <RoomInfWeb />

      {/* 검색버튼 */}
      <div className="row-center mt-[2.5rem]">
        <Button
          text={t("btn_hm_romInq")}
          styels="btn-search"
          disabled={dates.length < 2}
          onClick={() => {
            if (dates.length < 2) {
              alertControl({
                isOpen: true,
                inner: t("bck_ttl_hm_ldg_dt_slt"),
              });

              return;
            }
            navigate("book", {
              state: {
                dateRange,
                dates,
                promCd,
                lodNo,
              },
            });

            onBookInf({
              dateRange,
              dates,
              promCd,
              lodNo,
            });
          }}
        />
      </div>

      {/* 숙박정보 */}
      {/* <HomeLodInf /> */}
    </div>
  );
}
